module.exports = __webpack_public_path__ + "static/docHero-aced994afd5841e992c6ef3011bbd54b.png";